import React from 'react';

import AppController from 'RLX/Controllers/AppController';

class PaneController extends AppController {
  constructor (props) {
    super(props);
    this.render = this.render.bind(this);
    this.renderIndex = this.renderIndex.bind(this);
    this.renderSingle = this.renderSingle.bind(this);
  }

  renderSingle (id) {
    return (
      <h1 style={{textAlign: 'center', margin: '20vh 0'}}>
          Default Pane :: Single Item View :: @{id}
      </h1>
    );
  }

  renderIndex () {
    const style = {
      color: '#ccc',
      width: '100%',
      color: 'white',
      fontWeight: 200,
      textAlign: 'center',
      fontStyle: 'italic',
      letterSpacing: '20px'
    }
    return <h2 style={style}>(Coming Soon!)</h2>
  }

  render () {
    const { match } = this.props;
    const { params } = match;
    return (params && Object.keys(params).length && params.id)
      ? this.renderSingle(params.id)
      : this.renderIndex()
  }
};

export default PaneController;



// WEBPACK FOOTER //
// ./client/RLX/Controllers/PaneController.jsx